import * as yup from "yup";

export const pestanddiseaseInfo = yup.object().shape({
  diseaseName: yup.string(),
});

export const AgrowikilineItemSchema = yup.object().shape({
  companyName: yup.string(),
  seedsPhoto: yup.string(),
});

export const AgronomyWikiSchema = yup.object().shape({
  name: yup.string().required("Required"),
  articleType: yup.string(),
  classification: yup.string(),
  subCategory: yup.string(),
  scientificName: yup.string(),
  description: yup.string(),
  seedUrl: yup.string(),
  seedlingDuration: yup.string(),
  minGrowingTemperature: yup.string(),
  maxGrowingTemperature: yup.string(),
  minGrowingHumidity: yup.string(),
  maxGrowingHumidity: yup.string(),
  minPh: yup.string(),
  maxPh: yup.string(),
  minTds: yup.string(),
  maxTds: yup.string(),
  seedGerminationDays: yup.string(),
  twoLeavesDays: yup.string(),
  canPrune: yup.boolean(),
  generalServingSize: yup.string(),
  image: yup.string(),
  proneToPowderyMildew: yup.boolean(),
  proneToDownyMildew: yup.boolean(),
  proneToFusariumWilt: yup.boolean(),
  proneToAnthracnose: yup.boolean(),
  proneToRootRot: yup.boolean(),
  proneToLeafSpot: yup.boolean(),
  proneToBotrytisRot: yup.boolean(),
  proneToBacterialLeafSpot: yup.boolean(),
  proneToMosaicVirus: yup.boolean(),
  proneToLeafCurleVirus: yup.boolean(),
  proneToClubRoot: yup.boolean(),
  productionPerPlantPerCycle: yup.boolean(),
  difficultyToGrowInWinter: yup.string(),
  difficultyToGrowInSpring: yup.string(),
  difficultyToGrowInSummer: yup.string(),
  difficultyToGrowInMonsoon: yup.string(),
  difficultyToGrowInAutumn: yup.string(),
  difficultyToGrowInPrewinter: yup.string(),
  favouriteOnly: yup.boolean(),
  pestanddisease: yup.array().of(yup.string()),
  lineItems: yup.array().of(AgrowikilineItemSchema),
  ApplicableToPMG: yup.boolean(),
  plantPriceForFarmer: yup.number().when("ApplicableToPMG", {
    is: (val) => val === true,
    then: (s) => yup.string().required("Required"),
  }),
  plantPriceForCustomer: yup.number().when("ApplicableToPMG", {
    is: (val) => val === true,
    then: (s) => yup.string().required("Required"),
  }),
  cropSeason: yup.string(),
});
